import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Rooms from './pages/Rooms';
import Gallery from './pages/Gallery';
import RoomDetails from './pages/RoomDetails';
import Contact from './pages/Contact';
import Bookings from './pages/Bookings';
import './styles/App.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/rooms" element={<Rooms />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/room/:id" element={<RoomDetails />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/bookings/:id" element={<Bookings />} />
            </Routes>
        </Router>
    );
}

export default App;